export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";

export const langs: Record<string, { short: string; long: string }> = {
    vi: { short: "VI", long: "Tiếng Việt" },
    en: { short: "EN", long: "English" },
};

export const LANG_STORAGE_KEY = "LANGUAGE";

export const GOOGLE_RECAPTCHA_SITE_KEY = "6LfiVOYqAAAAANTQ0rnM2nMlnU5ZmFncJlp24IHc";
export const GOOGLE_MAP_ID = "5a97425d6795679b";
export const GOOGLE_MAP_API_KEY = "AIzaSyCjCTxRd6gqrEiodwgyQ8kv8IEEUYNbrxI";
